<template>
    <div v-show="!$vuetify.breakpoint.mobile" class="visual">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="banner in banners" :key="banner._id" class="swiper-slide">
                    <!-- <div v-if="banner.isUrl" class="background background--7" style="cursor: pointer;" @click="open(banner.open)">
                        <img :src="banner.image" alt="">
                    </div> -->
                    <div v-if="banner.isUrl">
                        <a class="background background--7" :href="banner.open">
                            <img :src="banner.image" alt="">
                        </a>
                    </div>
                    <div v-else>
                        <router-link class="background background--2" :to="banner.to">
                            <img :src="banner.image" alt="">
                        </router-link>
                    </div>
                </div>
                <!-- <div class="swiper-slide">
                    <a class="background background--7" href="https://smartstore.naver.com/korea-books/products/9569341704?NaPm=ct%3Dlu6lheh4%7Cci%3Da28d13e3474197d3d86794830e2b632e3b2e5609%7Ctr%3Dsls%7Csn%3D627310%7Chk%3D2ec2dd599537149cc34a8018bc4d870bff09308d" target="_blank">
                        <img src="/images/main/banner-pc7.jpg" alt="">
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="background background--1" href="/shop/ebook" >
                        <img src="/images/main/banner-pc1.jpg" alt="">
                    </a>
                </div>
                <div class="swiper-slide">
                    <router-link class="background background--2" to="/join">
                        <img src="/images/main/banner-pc2.jpg" alt="">
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="background background--3" to="/gshop/brand">
                        <img src="/images/main/banner-pc3.jpg" alt="">
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="background background--4" to="/shop/discount">
                        <img src="/images/main/banner-pc4.jpg" alt="">
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="background background--5" to="/shop/independent">
                        <img src="/images/main/banner-pc5.jpg" alt="">
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <a class="background background--6" href="https://www.daehanbooks.co.kr/shop/bestseller" target="_blank" >
                        <img src="/images/main/banner-pc6.jpg" alt="">
                    </a>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import { mdiPlay, mdiPause, mdiPlus, mdiClose } from '@mdi/js';

export default {
    props: {
        banners: { type: Array }
    },
    data(){
        return {
            mdiPlay,
            mdiPause,
            mdiPlus,
            mdiClose,

            visual: null,
            stop: false,
            dialog: false,

            loading: false
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.visual = new window.Swiper('.visual .swiper-container', {
                effect: 'fade',
                allowTouchMove: true,
                centeredSlides: true,
                spaceBetween : 0,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                speed: 700,
                loop: true,
                pagination: {
                    el: '.visual .slide-pagination',
                    clickable: true,
                },
                breakpoints: {
                    769:{
                        // allowTouchMove: false,
                    }
                },
                navigation: {
                    nextEl: '.visual .counter-plus',
                    prevEl: '.visual .prev'
                },
                // on: {
                //     init: function(){
                //         // IE Fade Effect
                //         if(!this.el.classList.contains('swiper-container-initialized')){
                //             this.el.classList.add('swiper-container-initialized');
                //         }
                //     },
                // }
            });
        })
    },
    methods: {
        swiperStop() {
            if (this.stop) {
                this.visual.autoplay.start()
                this.stop = false
            } else {
                this.visual.autoplay.stop()
                this.stop = true
            }
        },
        close() {
            this.dialog = false
        },
        open(url) {
            window.location.href = url;
        },
    },
}
</script>

<style scoped>
/* Visual */
.visual{
    overflow: hidden; position: relative; height: 755px; background: #ffffff;
}
.visual .swiper-container{
    height: 100%;
    /* -webkit-transition-property: all; transition-property: all;
    -webkit-transition-timing-function: ease-in-out; transition-timing-function: ease-in-out;
    opacity: 0; */
}
.visual .swiper-wrapper{
    height: 100%;
    -webkit-transition-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
    transition-timing-function: cubic-bezier(0.6, 0, 0.4, 1);
}
.visual .swiper-slide { overflow: hidden; height: 100%; }
.visual .prev,
.visual .next{
    z-index: 2; position: absolute; top: 0; bottom: 0; margin: auto; cursor: pointer !important;
    /* -webkit-transition: all .35s ease-out .6s; transition: all .35s ease-out .6s;
    opacity: 0; */
}
.visual .prev{
    left: 100px; width: 40px; height: 70px; background: url('/child/img/icon/prev.png') no-repeat center;
    -webkit-transform: translateX(-50px); transform: translateX(-50px);
}
.visual .next{
    right: 100px; width: 40px; height: 70px; background: url('/child/img/icon/next.png') no-repeat center;
    -webkit-transform: translateX(50px); transform: translateX(50px);
}
.visual .slide-pagination{
    -webkit-transition: all .45s ease-out .6s; transition: all .45s ease-out .6s;
    /* -webkit-transform: translateY(50px); transform: translateY(50px);
    opacity: 0; */
}
.visual .slide-pagination .name{
    display: block; margin-bottom: 6px; line-height: 1;
    font-size: 1.6rem; font-weight: 800; color: #ffffff;
    text-shadow: 0px 2px 6px rgba(56,56,56,.48);
    -webkit-transform: skew(-0.03deg); transform: skew(-0.03deg);
}
.visual-progress-container { display: block; background: rgba(255,255,255,.5); }
.visual-progress{
    display: block; position: relative;
    margin: 0; width: 110px; height: 3px;
    -webkit-transition: all ease .3s; transition: all ease .3s;
    opacity: 0;
}
.visual-progress .bar{
    position: absolute; top: 0; left: 0; width: 105%; height: 100%; background: #ffffff;
    -webkit-transform-origin: left; transform-origin: left;
    -webkit-transition-timing-function: linear; transition-timing-function: linear;
}
.visual-progress[data-state="on"] { opacity: 1; }
.visual-progress[data-state="off"] .bar {-webkit-transform: scaleX(0); transform: scaleX(0); transition-duration: 0ms !important; }
.visual-progress[data-state="on"] .bar {-webkit-transform: scaleX(1); transform: scaleX(1); transition-property: all; transition-timing-function: linear; }

.visual .slide-pagination.swiper-pagination-bullets { z-index: 2; position: absolute; bottom: 150px; width: 100%; text-align: center; font-size: 0; }
.visual .slide-pagination.swiper-pagination-bullets .swiper-pagination-bullet { margin: 0 5px; width: auto; height: auto; background: transparent; opacity: 1; }
.visual .background{
    display: -webkit-box; display: -ms-flexbox; display: flex;
    -webkit-box-align: center; -ms-flex-align: center; align-items: center;
    -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center;
    height: 100%; text-align: center;
    /* -webkit-transition: all ease-in-out 1s; transition: all ease-in-out 1s;
    -webkit-transform: scale(1.1); transform: scale(1.1); */
}
.visual .background img { max-width: none; }
.visual .context { font-size: 2.2rem; color: #ffffff; }
.visual .context .title { line-height: 1; margin-bottom: 30px; font-size: 5.4rem; font-weight: 800; text-shadow: 0px 3px 60px rgba(22,70,113,.8); }
.visual .context .title small { display: block; margin-bottom: 14px; font-size: 3.2rem; font-weight: 400; }
.visual .context p { text-shadow: 0px 3px 60px rgba(22,70,113,.8); }
/* .visual .background--1 { background: url('/child/img/main/v1.jpg') no-repeat center / auto 756px; }
.visual .background--2 { background: url('/child/img/main/v2.jpg') no-repeat center / auto 756px; }
.visual .background--3 { background: url('/child/img/main/v3.jpg') no-repeat center / auto 756px; }
.visual .background--4 { background: url('/child/img/main/v4.jpg') no-repeat center / auto 756px; }
.visual .background--5 { background: url('/child/img/main/v5.jpg') no-repeat center / auto 756px; } */
/* .visual .swiper-container-initialized { opacity: 1; }
.visual .swiper-container-initialized .background { -webkit-transform: none; transform: none; }
.visual .swiper-container-initialized .prev,
.visual .swiper-container-initialized .next,
.visual .swiper-container-initialized .slide-pagination{
    -webkit-transform: none; transform: none;
    opacity: 1;
} */
.slide-controls {
    position: absolute;
    z-index: 100;
    bottom: 120px;
    max-width: 1230px;
    padding: 0px 15px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.counter {
    background-color: grey;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
    margin-left: 40px;
}
.main-dialog-link {
    flex: 0 1 50%;
    width: 50%;
}
.main-dialog-img {
    width: 100%;
    display: block;
}
.main-dialog {
    display: flex;
    flex-wrap: wrap;
    /* overflow: hidden;
    overflow: scroll; */

}
.v-dialog {
    overflow-x: hidden;
    position: relative;
}

.close-box {
    position: fixed;
    right: 20px;
    top:10px;
    width: auto;
    box-shadow: none !important;
    background-color:transparent;
}
</style>